module.exports = __webpack_public_path__ + "images/paper-add.1792033684119.png";